// utils/userApi.js — administración de usuarios desde el panel
import apiClient from "./apiClient";

export function getUsersAdmin() {
  return apiClient.get("users");
}

export function createUserAdmin(user) {
  return apiClient.post("users", user);
}

export function updateUserAdmin(id, user) {
  return apiClient.put(`users/${id}`, user);
}

export function setUserBlockedAdmin(id, blocked) {
  return apiClient.patch(`users/${id}/block`, { blocked });
}
